import './style.scss'
import CalendarHeatmap from 'react-calendar-heatmap';
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
//import 'react-calendar-heatmap/dist/styles.css';

export const Heatmap: React.FC<any> = ({ data }) => {
    return (
        <div >
            <CalendarHeatmap
                startDate={new Date('2024-01-01')}
                endDate={new Date('2024-12-31')}
                values={data}
                horizontal={true}
                // gutterSize={5}
                showWeekdayLabels
                classForValue={(value: any) => {
                    if (!value) {
                        return 'color-empty';
                    }
                    return `color-scale-${value.count}`;
                }}
                tooltipDataAttrs={(value: any) => {
                    // Temporary hack around null value.date issue
                    if (!value || !value.date) {
                        return null;
                    }
                
                    if (value.date && value.count) {
                        return {
                        'data-tip': `Date ${value.date.slice(0, 10)} has the value ${value.count} `,
                        }
                    }
                    // Configuration for react-tooltip
                    return {
                        'data-tip': ` ${value.date} `,
                    };
                }}
            />
            <Tooltip id="data-tip" />
        </div>
    );
};
